import { useLazyQuery, useMutation } from "@apollo/client";
import { Card, Col, Row, Form, Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../components/form/CustomSelect";
import { GET_MEMBER_LIST } from "../../graphql/queries/management";
import CustomFormGroup from "../../components/form/CustomFormGroup";
import SubmitButton from "../../components/common/SubmitButton";
import { TOPUP } from "../../graphql/mutations/transaction";
import TransactionListTable from "./components/TransactionListTable";
import { GET_MEMBER_TRANSACTION_LIST } from "../../graphql/queries/transaction";
import { useEffect, useState } from "react";
import TopupRequestListTable from "./components/TopupRequestListTable";
import {
  clearTransaction,
  onChangeAmountTopup,
  selectCustomerTopup,
} from "../transaction/redux/transactionSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/common/CustomErrorMessage";
import {
  useMemberQuery,
  useTransactionRequestQuery,
} from "../../graphql/apollo/query-hooks";

const Topup = () => {
  const [key, setKey] = useState("approve");
  const transaction = useSelector((state) => state.transaction);
  const { topup } = transaction;
  const dispatch = useDispatch();
  const { memberList } = useMemberQuery();
  const { getTransactionRequests, refetchRequestList, loading } =
    useTransactionRequestQuery("TOPUP");

  const options = memberList?.map((s) => ({
    value: s.id,
    label: `${s.nickname}(${s.memberId})`,
  }));

  useEffect(() => {
    return () => {
      dispatch(clearTransaction());
    };
  }, [dispatch]);

  const [
    fetchTransaction,
    { data: { getMemberTransactionList } = {}, refetch },
  ] = useLazyQuery(GET_MEMBER_TRANSACTION_LIST, {
    variables: { member: topup.member, action: "TOPUP" },
    onError(er) {
      showErrorToast(er.message);
    },
  });

  const handleChangeMember = (e) => {
    dispatch(selectCustomerTopup(e.value));
    fetchTransaction();
  };
  const handleChangeAmount = (e) =>
    dispatch(onChangeAmountTopup(parseInt(e.target.value)));

  const [topupBalance, { loading: loadingCreate }] = useMutation(TOPUP, {
    variables: {
      input: {
        amount: topup.amount,
        member: topup.member,
      },
    },
    refetchQueries: [{ query: GET_MEMBER_LIST }],
    onCompleted: (data) => {
      if (data) {
        refetch();
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    topupBalance();
  };

  return (
    <Card className="lao">
      <Card.Header>
        <Card.Title>
          <h3 className="p-1">ເຕີມເງິນ</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
          <Tab eventKey="approve" title="ຢື່ນຢັນການເຕີ່ມຂອງລູກຄ້າ">
            <TopupRequestListTable
              data={getTransactionRequests}
              refetchRequestList={refetchRequestList}
              loading={loading}
            />
          </Tab>
          <Tab eventKey="topup" title="ເຕີມເອງ">
            <Row>
              <Col lg={6}>
                <Form onSubmit={handleSubmit}>
                  <CustomSelect
                    options={options}
                    handleChange={handleChangeMember}
                    placeholder="-- ເລືອກລູກຄ້າ --"
                  />
                  <CustomFormGroup
                    label="ຈຳນວນເງິນ"
                    name="amount"
                    onChange={handleChangeAmount}
                    type="number"
                    value={topup.amount}
                    placeholder="ຈຳນວນເງິນ"
                    errorParam="amount"
                    required={true}
                  />
                  <div className="text-center">
                    <SubmitButton loading={loadingCreate} />
                  </div>
                </Form>
              </Col>
              <Col lg={6}>
                {topup.member ? (
                  <div className="transaction-list">
                    <h3>ປະຫວັດການເຕີ່ມເງິນ</h3>
                    <TransactionListTable data={getMemberTransactionList} />
                  </div>
                ) : null}
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
};

export default Topup;
